import React from 'react';

const DEFAULT_LANG = 'ro_RO';
const DEFAULT_BUTTON_POSITION = 'left';

type MicAccessToolType = {
  new (options: {
    link: string,
    contact: string,
    buttonStyle: Record<string, any>,
    buttonClassName: string,
    buttonPosition: string,
    forceLang: string
  }): {
    create: () => void,
    destroy: () => void
  }
};

interface Options {
  enabled?: boolean,
  buttonClassName?: string,
  buttonStyle?: Record<string, any>,
  buttonPosition?: string
}

let MicAccessToolModule: MicAccessToolType | null = null;

export const useAccessibilityToolbar = (options?: Options) => {

  const {
    enabled = true,
    buttonClassName,
    buttonStyle = {},
    buttonPosition = DEFAULT_BUTTON_POSITION
  } = options || {};

  const toolbarRef = React.useRef(null);

  React.useEffect(() => {
    if (!enabled) return;

    let MicAccessToolInstance = null;

    const loadMicAccessTool = async () => {
      try {
        if (!MicAccessToolModule) {
          const module = await import('scripts/AccToolbar/acctoolbar.min');
          MicAccessToolModule = (module.default || module) as MicAccessToolType;
        }

        MicAccessToolInstance = new MicAccessToolModule({
          link: null,
          contact: null,
          buttonClassName,
          buttonStyle,
          buttonPosition,
          forceLang: DEFAULT_LANG
        });

        toolbarRef.current = MicAccessToolInstance;
        toolbarRef.current.create();
      } catch (error) {
        console.error('Failed to load MicAccessTool:', error);
      }
    };

    loadMicAccessTool();

    return () => {
      if (toolbarRef.current) {
        toolbarRef.current.destroy();
        toolbarRef.current = null;
      }
    };
  }, [
    enabled,
    buttonStyle,
    buttonClassName,
    buttonPosition
  ]);

};
